export enum RecaptchaActionsEnum {
  SUBMIT_APPLICATION = 'submit_application',
  COMPLETE_APPLICATION = 'complete_application',
  UPDATE_APPLICATION = 'update_application',
  RENEW_TOKEN = 'renew_token',
}
